import api from '../services/api';

const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;

function urlBase64ToUint8Array(base64String) {
  if (!base64String) return new Uint8Array();
  
  const padding = '='.repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/\-/g, '+')
    .replace(/_/g, '/');

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

export async function askNotificationPermission() {
  if (!("Notification" in window)) {
    console.log("This browser does not support desktop notification");
    return 'unsupported';
  }
  
  const permission = await Notification.requestPermission();
  return permission;
}

export async function registerServiceWorker() {
    // SW registration drives install + offline shell — keep it independent of
    // push support so the PWA is installable on browsers without PushManager.
    if (!('serviceWorker' in navigator)) {
        console.warn('Service Worker not supported — PWA install/offline unavailable');
        return null;
    }
    try {
        // Nudge any existing registration to fetch the latest sw.js.
        const registrations = await navigator.serviceWorker.getRegistrations();
        for (let registration of registrations) {
            await registration.update();
        }

        const registration = await navigator.serviceWorker.register('/sw.js?v=' + Date.now());
        console.log('Service Worker registered with scope:', registration.scope);
        if (!('PushManager' in window)) {
            console.warn('Push Notifications not supported on this browser (SW still active)');
        }
        return registration;
    } catch (error) {
        console.error('Service Worker registration failed:', error);
        return null;
    }
}

export async function subscribeToPushNotifications() {
    if (!VAPID_PUBLIC_KEY) {
        console.error('VAPID Public Key is missing in environment variables');
        return null;
    }

    const registration = await navigator.serviceWorker.ready;
    if (!registration) {
        console.error('Service Worker not ready');
        return null;
    }

    try {
        const subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY)
        });

        // Send subscription to backend
        // Assuming api.js has a generic post method or we add a specific one
        // Inspecting api.js first would be safer but standard pattern is:
        // api.post('/notifications/subscribe', subscription)
        
        // Let's assume we need to format it as the backend expects:
        // class SubscriptionCreate(BaseModel):
        //     endpoint: str
        //     keys: SubscriptionKeys (p256dh, auth)
        
        const subJson = subscription.toJSON();
        
        const payload = {
            endpoint: subJson.endpoint,
            keys: {
                p256dh: subJson.keys?.p256dh,
                auth: subJson.keys?.auth
            }
        };

        // We need to call the backend. Assuming api.js is the axios instance.
        // We'll return the response so the UI can handle success/fail.
        // Since we imported 'api', we can use it.
        // CHECK if api has 'notifications' service set up or if we use raw url?
        // User Management service is on port 8001 usually or via Gateway 8000.
        // React App probably points to Gateway 8000.
        // Endpoint: /api/v1/notifications/subscribe
        
        const response = await api.post('/notifications/subscribe', payload);
        return response.data;
        
    } catch (error) {
        console.error('Failed to subscribe:', error);
        throw error;
    }
}

export async function unsubscribeFromPushNotifications() {
    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.getSubscription();
    
    if (subscription) {
        // Unsubscribe locally
        await subscription.unsubscribe();
        
        // Notify backend
        const endpoint = subscription.endpoint;
        try {
            await api.post('/notifications/unsubscribe', { endpoint });
        } catch (e) {
            console.warn('Backend unsubscribe failed', e);
        }
    }
}
